import React, { useContext, useEffect } from "react";
import { Context } from "../../services/auth";
import { ContextGetData } from "../../services/getData";

import "./styles.scss";

const Cookies = () => {
  const { handleAcceptCookies } = useContext(Context);
  const { idConta } = useContext(ContextGetData);

  useEffect(() => {
    if (localStorage.getItem("acceptedCookies") == null)
      setTimeout(() => {
        addClass("showCookieBanner");
      }, 500);
    else addClass("hideCookieBanner");
  }, []);

  const aceitaCookies = async () => {
    addClassOnClickToHide();
    await handleAcceptCookies(idConta);
    localStorage.setItem("acceptedCookies", true);
  };

  function addClassOnClickToHide() {
    document
      .getElementsByClassName("cookieBanner")[0]
      .classList.add("hideCookieBannerOnClick");
  }

  function addClass(classname) {
    document.getElementsByClassName("cookieBanner")[0].classList.add(classname);
  }

  return (
    <div className="centralized bannerFullPage">
      <div className="cookieBanner centralized  ">
        <p>
          Utilizamos cookies em nosso site para melhorar sua
          <span>
            {" "}
            experiência de navegação, desempenho e construir conteúdo
            personalizado.
          </span>
          <span> Para mais informações</span>
          <a href="#"> acesse a nossa Política de Privacidade</a>.
        </p>
        <div className="cookieBanner__buttons centralized-space-evenly">
          <button
            className="cookieBanner__buttons__accept"
            onClick={() => {
              aceitaCookies();
            }}
            id="btnAceitarCookies"
          >
            CONCORDO
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
